import { Handler, OddsFormatIframe, OddsFormatPayload } from "../common/types";
import { IframeActions } from "../common/events";
import { logger } from "../services/logger";

export const oddsFormatChange: Handler<OddsFormatPayload> = (
  payload,
  { iframe },
) => {
  logger.log(`[From MsgBus]: Odds format change: `, payload);
  iframe.publish(IframeActions.ODDS_FORMAT, {
    format: OddsFormatIframe[payload],
  });
};
